import React, { Component } from "react";
import { Button } from "react-bootstrap";
import "./HomePage.scss";
import { connect } from "react-redux";
import { SelectTopclient } from "../../redux/actions/Top5";
import { SelectTopFrs } from "../../redux/actions/Top5Frs";
import FTChart from "./FTChart";
import AchatChart from "./AchatChart";
import translate from "../../i18n/translate";

class TabBLFT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      change: false,
    };
  }

  componentDidMount() {}

  render() {
    const { darck } = this.props;
    return (
      <div>
        <div>
          <Button
            onClick={() => this.setState({ change: false })}
            variant="outline-info"
          >
            {translate("BL")}
          </Button>{" "}
          &nbsp;
          <Button
            onClick={() => this.setState({ change: true })}
            variant="outline-danger"
          >
            {translate("Facture")}
          </Button>
        </div>
        <div>
          {this.state.change ? (
            <div>
              <p className={darck ? "p1" : "p1Darck"} style={{ margin: "10px" }}>
                {translate("Total Montant des Factures par jour")}
              </p>
              <FTChart />
            </div>
          ) : (
            <div>
              <p className={darck ? "p1" : "p1Darck"} style={{ margin: "10px" }}>
                {translate("Total Montant des BL par jour")}
              </p>
              <AchatChart></AchatChart>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SelectTopclient: () => dispatch(SelectTopclient()),
    SelectTopFrs: () => dispatch(SelectTopFrs()),
  };
}

function mapStateToProps(state) {
  return {
    tops: state.tops,
    topfrss: state.topfrss,
    darck: state.darck.darck,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TabBLFT);
